var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Footer'),(_vm.showContactButton)?_c('button',{staticClass:"floating-service-btn",attrs:{"type":"button"},on:{"click":_vm.contactService}},[_c('span',{staticClass:"floating-service-btn__text"},[_vm._v(_vm._s(_vm.$t('common.contact_service')))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }